module.exports = __webpack_public_path__ + "img/2ezBanner1.42de4882.jpg";